import styled from 'styled-components'

export const Paragraph = styled.p`
	font-size: 0.8em;
	font-weight: ${(p) => p.theme.font.sans.weight.bold};
	letter-spacing: ${(p) => p.theme.font.sans.spacing.slim};
	line-height: 1.75;
`
